// extracted by mini-css-extract-plugin
export default {"loginForm":"loginForm_loginForm__U9vVC","badCredentials":"loginForm_badCredentials__MfpyV","form":"loginForm_form__L+Cvq","group":"loginForm_group__97UMO"};